import React, { useRef } from "react";
import { Document, Page } from "react-pdf";
import { Box } from "@mui/material";
import FormFieldOverlayLayer from "../overlays/FormFieldOverlayLayer";

const PreviewPDF = ({
  base64File,
  pdfInput,
  currentProcessingFile,
  setCurrentProcessingFile,
  pageNumber,
  onDocumentLoadSuccess,
  onPageLoadSuccess,
}) => {
  const previewContainerRef = useRef(null);
  const previewDocumentRef = useRef(null);

  return (
    <Box display="flex" justifyContent="center">
      <Box
        ref={previewContainerRef}
        sx={{
          position: "relative",
          display: "inline-block",
          border: "2px solid #d3d3d3",
          borderRadius: "18px",
          boxShadow: "3px 4px 12px rgba(0,0,0,0.3)",
          backgroundColor: "#fff",
          userSelect: "none",
        }}
      >
        <Document
          file={base64File || pdfInput}
          onLoadSuccess={onDocumentLoadSuccess}
          ref={previewDocumentRef}
        >
          <Page
            pageNumber={pageNumber}
            scale={1}
            renderTextLayer={false} // hide selectable text layer in preview
            renderAnnotationLayer={false}
            onLoadSuccess={onPageLoadSuccess}
          />
        </Document>

        {/* Render fields as read-only overlays */}
        <FormFieldOverlayLayer
          currentProcessingFile={currentProcessingFile}
          pageNumber={pageNumber}
          scale={1}
          selectToolActive={false} // no selection in preview
          typingToolActive={false}
          highlightFields={false} // no yellow highlight
          textOverlayDisplayMode="none"
          focusedField={null}
          setFocusedField={() => {}}
          currCursor="default"
          unassignedFieldNames={[]}
          fixedInputs={[]}
          inputRef={null}
          childInputRef={null}
          pdfContainerRef={previewContainerRef}
          setCurrentProcessingFile={setCurrentProcessingFile}
          // All interaction handlers are no-ops in preview
          setStartPoint={() => {}}
          setRect={() => {}}
          setIsDrawing={() => {}}
          setCurrCursor={() => {}}
          setFreeSelectStartPoint={() => {}}
          setMoving={() => {}}
          setIsSelecting={() => {}}
          setInitialMousePosition={() => {}}
          setInitialInputSize={() => {}}
          setInputPosition={() => {}}
          setSelectionRect={() => {}}
          setResizing={() => {}}
          setResizeDirection={() => {}}
          handleMouseDown={() => {}}
          handleFieldChange={() => {}}
          undoRedoStats={null}
          activeEditorTool="hand"
          isPreview={true}
        />
      </Box>
    </Box>
  );
};

export default PreviewPDF;
